import { SVGProps } from 'react';

/** {@link PinIcon} with a slash, for the unpin state. */
export const UnpinIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      <mask id="unpinIconSlashMask" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect x="0" y="0" width="24" height="24" fill="white" />
        <line x1="6.8" y1="2.8" x2="21.2" y2="17.2" stroke="black" strokeWidth={5} strokeLinecap="round" />
      </mask>
      <g mask="url(#unpinIconSlashMask)">
        <g transform="rotate(45 12 12)">
          <line x1="12" y1="17" x2="12" y2="23" />
          <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z" />
        </g>
      </g>
      <line x1="6.8" y1="2.8" x2="21.2" y2="17.2" />
    </svg>
  );
};
